import {styled} from '@mui/material/styles';

export default function TH() {
    return (
        <Agreement>
            <h1>📄 ข้อตกลงการลงทุนของนักลงทุน</h1>
            <h2>ข้อตกลงการลงทุนของผู้ลงทุนในระบบการเงินห่วงโซ่อุปทาน IGE RWA</h2>
            <p><strong>หมายเลขรุ่น:</strong> IGE-RWA-2025V1.0</p>
            <p><strong>วันที่มีผลบังคับใช้:</strong> การลงนามจะมีผลทันทีเมื่อบันทึกบนบล็อกเชนแล้ว</p>
            <p>โปรดอ่านข้อตกลงนี้อย่างรอบคอบ เมื่อคุณเลือก “ยอมรับและดำเนินการต่อ” ถือว่าคุณได้อ่าน เข้าใจ และยอมรับเนื้อหาทั้งหมดของข้อตกลงนี้ และยอมปฏิบัติตามข้อกำหนดที่เกี่ยวข้อง</p>

            <h3>• คู่สัญญาของข้อตกลง</h3>
            <p>ข้อตกลงนี้จะลงนามร่วมกันโดย IGE International Gold Exchange Limited (ต่อไปนี้เรียกว่า "แพลตฟอร์ม" หรือ "IGE") และผู้ใช้ที่ลงทะเบียนและใช้รูปแบบการลงทุน IGE RWA (ต่อไปนี้เรียกว่า “นักลงทุน” หรือ “คุณ”)</p>

            <h3>• ภาพรวมของธุรกิจ</h3>
            <ul>
                <li>2.1 IGE ใช้เทคโนโลยี RWA (การนำสินทรัพย์ในโลกจริงมาอยู่บนบล็อกเชน) เพื่อทำให้การซื้อขายทองคำในตลาดใหญ่เป็นดิจิทัล ซึ่งช่วยให้นักลงทุนทั่วไปสามารถเข้าร่วมตลาดทองคำทั่วโลกได้ และสามารถลงทุนได้ด้วยเกณฑ์ที่ต่ำ</li>
                <li>2.2 คุณสามารถลงทุนในสินทรัพย์ทองคำผ่านแพลตฟอร์มนี้ และรับผลตอบแทนตามข้อกำหนดของแพลตฟอร์ม</li>
                <li>2.3 เงินลงทุนของคุณจะใช้ในการซื้อขายทองคำ และผลกำไรจะมาจากส่วนต่างราคาตลาดทองคำ</li>
            </ul>

            <h3>• กฎการลงทุน</h3>
            <ul>
                <li>3.1 จำนวนเงินลงทุนขั้นต่ำ: ไม่มีเกณฑ์การลงทุนที่กำหนด ผู้ใช้สามารถลงทุนได้ตามความต้องการ</li>
                <li>3.2 ระยะเวลาการลงทุน: 7 วัน (เริ่มนับเวลาเมื่อชุดสินทรัพย์เต็ม)</li>
                <li>3.3 อัตราผลตอบแทน: มาตรฐานคือ 1.2% / 7 วัน ผลตอบแทนจะคำนวณจากจำนวนเงินลงทุน และจะคืนเข้าบัญชีหลังจากสิ้นสุดระยะเวลา</li>
                <li>3.4 การแจกจ่ายผลตอบแทน: เมื่อสิ้นสุดระยะเวลาการลงทุน ผู้ใช้สามารถเลือกที่จะถอนหรือรีลงทุน</li>
                <li>3.5 การถอนก่อนกำหนด: ไม่สามารถถอนก่อนกำหนดในระหว่างระยะเวลาการลงทุน ต้องถือไว้จนกว่าจะครบกำหนด</li>
                <li>3.6 หากชุดสินทรัพย์ไม่เต็มภายใน 48 ชั่วโมง เงินลงทุนจะถูกคืนเต็มจำนวนกลับไปยังบัญชีของนักลงทุน</li>
            </ul>

            <h3>• การจัดการเงิน</h3>
            <ul>
                <li>4.1 การรับประกันความปลอดภัยของเงินทุน: เงินของคุณจะถูกใช้ในการซื้อขายทองคำจริงและได้รับการตรวจสอบโดยธนาคาร บริษัทประกันภัย และสถาบันบุคคลที่สามตลอดกระบวนการ</li>
                <li>4.2 กฎการถอน: การถอนจะต้องเป็นไปตามขั้นตอนของแพลตฟอร์ม และโดยปกติจะโอนเงินในเวลา 1-2 นาทีหลังจากดำเนินการบนบล็อกเชน</li>
                <li>4.3 ค่าธรรมเนียม: แพลตฟอร์มคิดค่าธรรมเนียม 5‰</li>
            </ul>

            <h3>• คำเตือนความเสี่ยง</h3>
            <ul>
                <li>5.1 ความเสี่ยงด้านสภาพคล่อง: การลงทุนจะต้องถือไว้จนกว่าจะครบกำหนดและไม่สามารถถอนก่อนกำหนดได้ กรุณาวางแผนการเงินให้เหมาะสม</li>
                <li>5.2 เหตุสุดวิสัย: IGE จะไม่รับผิดชอบต่อความเสียหายที่เกิดจากเหตุสุดวิสัย เช่น สงคราม การปรับนโยบายของรัฐบาล หรือความล้มเหลวของระบบ</li>
            </ul>

            <h3>• สิทธิและหน้าที่ของผู้ใช้</h3>
            <ul>
                <li>6.1 สิทธิของคุณ
                <ul>
                    <li>สิทธิในการตรวจสอบผลตอบแทนจากการลงทุน การถอน หรือการรีลงทุนและข้อมูลที่เกี่ยวข้อง</li>
                    <li>สิทธิในการลงทุนอย่างอิสระภายในขอบเขตที่แพลตฟอร์มกำหนด และได้รับผลตอบแทนที่เหมาะสม</li>
                </ul>
                </li>
                <li>6.2 หน้าที่ของคุณ
                <ul>
                    <li>รับรองข้อมูลส่วนบุคคลที่คุณให้เป็นข้อมูลที่ถูกต้องและเป็นจริง ไม่ใช้ตัวตนของบุคคลอื่นในการลงทะเบียนหรือลงทุน</li>
                    <li>ปฏิบัติตามกฎหมายและข้อบังคับที่เกี่ยวข้องของประเทศ รวมถึงกฎของแพลตฟอร์ม และไม่ใช้แพลตฟอร์มในการทำกิจกรรมที่ผิดกฎหมาย</li>
                </ul>
                </li>
            </ul>

            <h3>• สิทธิและหน้าที่ของ IGE</h3>
            <ul>
                <li>7.1 แพลตฟอร์มสัญญาที่จะจัดการเงินลงทุนอย่างเข้มงวดและรับประกันความโปร่งใสและการปฏิบัติตามกฎข้อบังคับในการซื้อขายทองคำ</li>
                <li>7.2 แพลตฟอร์มมีสิทธิในการระงับหรือยุติบัญชีของผู้ใช้หากพบการกระทำผิด</li>
            </ul>

            <h3>• กฎหมายที่ใช้บังคับและการแก้ไขข้อพิพาท</h3>
            <ul>
                <li>8.1 ข้อตกลงนี้อยู่ภายใต้กฎหมายของประเทศที่แพลตฟอร์มดำเนินการ (เช่น ประเทศไทย หรือสถานที่ตั้งสำนักงานใหญ่ของ IGE)</li>
                <li>8.2 ในกรณีที่เกิดข้อพิพาท ทั้งสองฝ่ายจะต้องเจรจาเพื่อหาทางออก หากไม่สามารถเจรจาได้ ข้อพิพาทจะถูกส่งไปยังศาลในท้องที่เพื่อดำเนินการตัดสิน</li>
            </ul>

            <h3>• ข้อกำหนดอื่นๆ</h3>
            <ul>
                <li>9.1 IGE มีสิทธิในการตีความข้อตกลงนี้เป็นที่สุด</li>
                <li>9.2 IGE มีสิทธิในการปรับปรุงเนื้อหาของข้อตกลงนี้ตามสภาพตลาด และข้อตกลงที่แก้ไขแล้วจะประกาศในแพลตฟอร์ม และผู้ใช้ต้องอ่านใหม่และยอมรับก่อนที่จะดำเนินการลงทุนต่อ</li>
                <li>9.3 IGE ไม่ให้บริการการลงทุนแก่ผู้ใช้ในพื้นที่ที่ USDT ไม่ได้รับการรับรองตามกฎหมาย</li>
            </ul>

            <p>กรุณายืนยันว่าคุณได้อ่านและเข้าใจข้อตกลงนี้ หากไม่มีข้อโต้แย้ง โปรดคลิก "ยอมรับ" เพื่อดำเนินการลงทุนต่อ</p>

        </Agreement>

    )
}

const Agreement = styled('div')`
    font-family: "Noto Sans TC", sans-serif;
    line-height: 1.6;
    padding: 20px;
    color: #eaeaea;
    & h1, & h2 {
        text-align: center;
        margin-bottom: 10px;
    }
    & h3 {
        margin-top: 20px;
        font-weight: bold;
        color: #b3b3b3;
    }

    ul {
        margin-left: 20px;
    }
`